export function usePDFViewer() {
    /**
     * Get a new adobePdfViewer instance.
     * @param {(instance: Object) => void} callback Execute a callback if the sdk is ready.
     * If the SDK isn't ready this will return false.
     * @return void|false
     */
    function getAdobePdfViewer(callback) {
        try {
            callback(
                new window.AdobeDC.View({
                    clientId: window.data.providers.adobe.pdf_client_id,
                })
            );
        } catch {
            return false;
        }
    }

    function viewInlinePdf(
        url,
        filename = 'PDF Document',
        params = {
            metaData: {},
            options: {},
        }
    ) {
        return getAdobePdfViewer(async (viewer) => {
            window.location = '#';

            await viewer.previewFile(
                {
                    content: (() => {
                        return {
                            location: {
                                url: url,
                            },
                        };
                    })(),
                    metaData: {
                        // If a local `File` is passed in, we use its name. If it's from us, we use the model's filename.
                        fileName: filename,
                        ...params.metaData,
                    },
                },
                {
                    embedMode: 'LIGHT_BOX',
                    ...params.options,
                }
            );
        });
    }

    return {
        viewInlinePdf,
    };
}
